import { render, staticRenderFns } from "./PaymentFooter.vue?vue&type=template&id=23cac332&scoped=true&"
import script from "./PaymentFooter.vue?vue&type=script&lang=js&"
export * from "./PaymentFooter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFooter.vue?vue&type=style&index=0&id=23cac332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cac332",
  null
  
)

export default component.exports